import React, {Component} from "react";
import {Buffer} from "buffer";
import {Col, message, Input, Row, Image, Spin, Button, Modal, Divider} from "antd";
import {offerGeneralApiService} from "../../services/offer/OfferGeneralApiService";
import Cookies from "universal-cookie";
import CurrencyInput from "react-currency-input-field";
import currencyFormat from "../../helper/currencyFormat";
import Search from "antd/es/input/Search";
import {promoServices} from "../../services/promo/PromoService";
import {appIntVersion} from "../../config/data/appConfig";
import {CheckCircleTwoTone} from "@ant-design/icons";

// import {ocrBpkbService} from "../../services/ocrImage/OcrBpkbService";

class QcLoan extends Component<any, any> {
    private readonly initState!: any;
    private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());

    constructor(props: any) {
        super(props);
        this.initState = {
            companyCode: "",
            offerCode: "",
            dataDetailOffer: {},
            fetchingDetailGeneralOffer: false,
            qcProcess: false,
            fetchCommission: false,
            disableCommission: false,
            resultOcr: {},
            ocrResultBpkbNumber: "",
            ocrResultEngineNumber: "",
            ecrResultChassisNumber: "",
            commissionCode: "",
            fincoCommission: 0,
            agentCommission: 0,
            freezeStatusDiffName: "",

            customerDataValid: false,
            customerBankAccount: {},
            customerInquiryAccountResponse: {},
            agentDataValid: false,
            agentBankAccount: {},
            agentInquiryAccountResponse: {},
            validateCustomerAccountBank: false,
            validateAgentAccountBank: false,

            fetchValidateBankAccount: false,
            freezeStatusWrongData: false,
            freezeStatusWrongDataText: "",
        };
        this.state = {...this.initState};
    }

    async componentDidMount() {
        await this.promisedSetState({
            offerCode: this.props.offerCode,
            companyCode: this.props.companyCode,
            fetchingDetailGeneralOffer: true,
        });

        await this.showOfferDetail();
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.offerCode !== prevProps.offerCode) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                companyCode: this.props.companyCode,
                fetchingDetailGeneralOffer: true,
            });
        }

        if (this.props.companyCode !== prevProps.companyCode) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                companyCode: this.props.companyCode,
                fetchingDetailGeneralOffer: true,
            });
        }

        if (this.props.time !== prevProps.time) {
            await this.showOfferDetail();
        }
    }

    showOfferDetail = async () => {
        this.promisedSetState({
            ocrResultBpkbNumber: "",
            ocrResultEngineNumber: "",
            ecrResultChassisNumber: "",
            commissionCode: "",
            fincoCommission: 0,
            agentCommission: 0,
            fetchValidateBankAccount: false,

            customerDataValid: false,
            customerBankAccount: {},
            customerInquiryAccountResponse: {},
            agentDataValid: false,
            agentBankAccount: {},
            agentInquiryAccountResponse: {},

            validateCustomerAccountBank: false,
            validateAgentAccountBank: false,
        });

        await offerGeneralApiService
            .getDetailOffer({
                offerCode: this.state.offerCode,
                companyCode: this.props.companyCode,
            }).then(async (value) => {
                const dataDetailOffer = value.data.data;
                let customerDataValid = false;
                let agentDataValid = false;
                if (dataDetailOffer?.bank_account?.bank_name && dataDetailOffer?.bank_account?.bank_code && dataDetailOffer?.bank_account?.account_number && dataDetailOffer?.bank_account?.bank_short_name && dataDetailOffer?.bank_account?.account_name) {
                    customerDataValid = true;
                }
                if (dataDetailOffer?.agent_bank_account?.bank_name && dataDetailOffer?.agent_bank_account?.bank_code && dataDetailOffer?.agent_bank_account?.account_number && dataDetailOffer?.agent_bank_account?.bank_short_name && dataDetailOffer?.agent_bank_account?.account_name) {
                    agentDataValid = true;
                }

                let commissionCode = (dataDetailOffer?.detail_commission?.[0]?.code) ? dataDetailOffer?.detail_commission?.[0]?.code : "";
                await this.promisedSetState({
                    fetchingDetailGeneralOffer: false,
                    commissionCode: commissionCode,
                    dataDetailOffer: dataDetailOffer,
                    fetchCommission: false,
                    disableCommission: false,
                    fincoCommission: dataDetailOffer?.credit?.finco_commission || 0,
                    agentCommission: dataDetailOffer?.credit?.agent_commission || 0,

                    customerBankAccount: dataDetailOffer?.bank_account,
                    agentBankAccount: dataDetailOffer?.agent_bank_account,
                    customerDataValid: customerDataValid,
                    agentDataValid: agentDataValid,
                    validateCustomerAccountBank: false,
                    validateAgentAccountBank: false,

                    ocrResultBpkbNumber: dataDetailOffer?.qc_data?.bpkb_number || "",
                    ocrResultEngineNumber: dataDetailOffer?.qc_data?.engine_number || "",
                    ecrResultChassisNumber: dataDetailOffer?.qc_data?.chassis_number || "",
                });

                const sleep = (waitTimeInMs: number) => new Promise((resolve) => setTimeout(resolve, waitTimeInMs));
                await sleep(100);
            }).catch(async (reason) => {
                await this.promisedSetState({
                    fetchingDetailGeneralOffer: false,
                    dataDetailOffer: {},
                    fetchCommission: false,
                    disableCommission: false,
                });
            });

        // try {
        //     const dataOcr = await ocrBpkbService.getData({
        //         category: this.state.chosenOfferRow?.product?.category || "motorcycle",
        //         document_year: this.state.chosenOfferRow?.product?.year || "2024",
        //         documents: docOcr
        //     });
        //     this.promisedSetState({
        //         ocrProcess: false,
        //         qcProcess: false,
        //         resultOcr: dataOcr.data?.data,
        //         ocrResultBpkbNumber: dataOcr.data?.data?.bpkb_number?.toUpperCase(),
        //         ocrResultEngineNumber: dataOcr.data?.data?.engine_number?.toUpperCase(),
        //         ecrResultChassisNumber: dataOcr.data?.data?.chassis_number?.toUpperCase(),
        //     })
        // } catch (e) {
        //     this.promisedSetState({
        //         ocrProcess: false,
        //         qcProcess: false,
        //         resultOcr: {},
        //         ocrResultBpkbNumber: "",
        //     })
        // }
    };

    onFieldChange = <T extends keyof Pick<any, "commissionCode" | "fincoCommission" | "agentCommission" | "ocrResultBpkbNumber" | "searchPoCode" | "searchOfferCode" | "filterStartDate" | "filterEndDate" | "filterOfferStatus" | "filterPurchaseMethod" | "ocrResultEngineNumber" | "ecrResultChassisNumber">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "commissionCode":
                currentState.commissionCode = value?.toUpperCase()?.trim();
                currentState.disableCommission = false;
                break;
            case "fincoCommission":
                currentState.fincoCommission = value;
                break;
            case "agentCommission":
                currentState.agentCommission = value;
                break;
            case "ocrResultEngineNumber":
                currentState.ocrResultEngineNumber = value;
                break;
            case "ecrResultChassisNumber":
                currentState.ecrResultChassisNumber = value;
                break;
            case "ocrResultBpkbNumber":
                currentState.ocrResultBpkbNumber = value;
                break;
            case "searchPoCode":
                currentState.searchPoCode = value;
                break;
            case "searchOfferCode":
                currentState.searchOfferCode = value;
                break;
            case "filterStartDate":
                currentState.filterStartDate = value;
                break;
            case "filterEndDate":
                currentState.filterEndDate = value;
                break;
            case "filterOfferStatus":
                currentState.filterOfferStatus = value;
                if (value === "qc") {
                    currentState.searchType = "qc";
                } else {
                    currentState.searchType = "date";
                }
                break;
            case "filterPurchaseMethod":
                currentState.filterPurchaseMethod = value;
                break;
        }
        currentState.dataOffer = [];
        this.setState({
            ...currentState,
        });
    }

    onValidate = async (data: any) => {
        await this.promisedSetState({fetchValidateBankAccount: true, freezeStatusWrongDataText: ""});

        let bankCode = "";
        let accountNumber = "";
        let accountName = "";
        if (data === "customer") {
            bankCode = this.state.customerBankAccount?.bank_code?.toUpperCase();
            accountNumber = this.state.customerBankAccount?.account_number?.toUpperCase();
            accountName = this.state.customerBankAccount?.account_name?.toUpperCase();
        }
        if (data === "agent") {
            bankCode = this.state.agentBankAccount?.bank_code?.toUpperCase();
            accountNumber = this.state.agentBankAccount?.account_number?.toUpperCase();
            accountName = this.state.agentBankAccount?.account_name?.toUpperCase();
        }

        try {
            offerGeneralApiService.setToken(this.props.token);
            const validateBankResult = await offerGeneralApiService.validateBank({bankCode: bankCode, accountNumber: accountNumber});
            if (validateBankResult.beneficiaryAccountName === accountName) {
                if (data === "customer") {
                    this.setState({
                        fetchValidateBankAccount: false,
                        customerInquiryAccountResponse: validateBankResult,
                    });
                }
                if (data === "agent") {
                    this.setState({
                        fetchValidateBankAccount: false,
                        agentInquiryAccountResponse: validateBankResult,
                    });
                }
                message.open({type: 'success', content: 'validasi rekening sukses'});
            } else {
                const diffName = `Nama Rekening Input : ${accountName} <br/> Nama Rekening Bank : ${validateBankResult.beneficiaryAccountName}`;
                if (data === "customer") {
                    const customerBankAccount = {...this.state.customerBankAccount};
                    customerBankAccount.account_name = validateBankResult.beneficiaryAccountName;
                    this.setState({
                        fetchValidateBankAccount: false,
                        customerBankAccount: customerBankAccount,
                        customerInquiryAccountResponse: validateBankResult,
                        freezeStatusChangeName: true,
                        freezeStatusDiffName: diffName
                    });
                }
                if (data === "agent") {
                    const agentBankAccount = {...this.state.agentBankAccount};
                    agentBankAccount.account_name = validateBankResult.beneficiaryAccountName;
                    this.setState({
                        fetchValidateBankAccount: false,
                        agentBankAccount: agentBankAccount,
                        agentInquiryAccountResponse: validateBankResult,
                        freezeStatusChangeName: true,
                        freezeStatusDiffName: diffName
                    });
                }
            }
        } catch (e: any) {
            this.setState({freezeStatusWrongData: true, freezeStatusWrongDataText: e?.toString()});
        }
    }

    onSearch = async (value: any) => {
        if (value) {
            await this.promisedSetState({fetchCommission: true});
            try {
                const dataCommission: any = await promoServices.getDetailCommission({
                    companyCode: this.props.companyCode,
                    commissionCode: value?.trim(),
                    ignoreTransactionDate: this.state.dataDetailOffer?.transaction_time,
                    agentCode: this.state.dataDetailOffer?.agent_code || "",
                    fincoCode: this.state.dataDetailOffer?.credit?.finco_code,
                    loan: this.state.dataDetailOffer?.credit?.disbursed_amount,
                    tenor: this.state.dataDetailOffer?.credit?.tenor,
                    category: this.state.dataDetailOffer?.product?.category,
                    transactionType: this.state.dataDetailOffer?.transaction_type
                })
                await this.promisedSetState({
                    fetchCommission: false,
                    fincoCommission: dataCommission?.net_commission_in,
                    agentCommission: dataCommission?.net_commission_out,
                    disableCommission: true,
                });
                message.open({type: 'success', content: 'kode komisi berhasil diterapkan'});

            } catch (e) {
                Modal.error({title: 'Proses Gagal', content: 'Server Menolak Inputan Anda :' + e});
                await this.promisedSetState({fetchCommission: false, disableCommission: false});
            }
        }
    }

    saveBeforeQc = async () => {
        const updateData = {
            update_type: "update-before-qc",
            app_otodis_version: appIntVersion,
            company: this.props.companyCode,
            admin_id: this.user,
            admin_name: this.user,
            offer_code: this.state.offerCode,
            commission_codes: (this.state.commissionCode) ? [this.state.commissionCode] : [],
            finco_commission: this.state.fincoCommission,
            agent_commission: this.state.agentCommission,
            qc_update_data: {
                bpkb_number: this.state.ocrResultBpkbNumber || null,
                engine_number: this.state.ocrResultEngineNumber || null,
                chassis_number: this.state.ecrResultChassisNumber || null,
            }
        }

        await this.promisedSetState({qcProcess: true});
        try {
            await offerGeneralApiService.setToken(this.props.token);
            await offerGeneralApiService.updateOffer(updateData)
                .then(async successData => {
                    Modal.success({
                        title: 'Proses update Sukses',
                        content: 'update data berhasil dilakukan',
                    });
                    await this.promisedSetState({qcProcess: false});
                    this.props.onCloseUpdateOwnerIdCardProps("close");
                });
        } catch (e) {
            Modal.error({title: 'Proses Gagal', content: 'Server Menolak Inputan Anda :' + e});
            await this.promisedSetState({qcProcess: false});
        }
    }

    finalQc = async () => {
        if (!this.state.agentDataValid) {
            if (this.state.agentCommission !== 0) {
                return Modal.error({title: 'Proses Gagal', content: 'mohon lengkapi data akun bank agent(mediator)'});
            }
        }
        if (this.state.customerDataValid) {
            if (!this.state.customerInquiryAccountResponse?.beneficiaryAccountName) {
                return Modal.error({title: 'Proses Gagal', content: 'mohon lakukan validasi akun bank konsumen'});
            }
        }
        if (!this.state.agentInquiryAccountResponse?.beneficiaryAccountName) {
            if (this.state.agentCommission !== 0) {
                return Modal.error({title: 'Proses Gagal', content: 'mohon lakukan validasi akun bank agent(mediator)'});
            }
        }

        if (!this.state.disableCommission) {
            return Modal.error({title: 'Proses Gagal', content: 'mohon terapkan kode komisi terlebih dahulu'});
        }

        const qcData = {
            update_type: "qc-offer",
            app_otodis_version: appIntVersion,
            company: this.props.companyCode,
            admin_id: this.user,
            admin_name: this.user,
            offer_code: this.state.offerCode,
            commission_codes: (this.state.commissionCode) ? [this.state.commissionCode] : [],
            finco_commission: this.state.fincoCommission,
            agent_commission: this.state.agentCommission,
            ocr_result: this.state.resultOcr,
            qc_update_data: {
                bpkb_number: this.state.ocrResultBpkbNumber || null,
                engine_number: this.state.ocrResultEngineNumber || null,
                chassis_number: this.state.ecrResultChassisNumber || null,
            },
            bank_account_data: {
                customer_data_valid: this.state.customerDataValid,
                customer_bank_account: this.state.customerBankAccount,
                customer_inquiry_account_response: this.state.customerInquiryAccountResponse,
                agent_data_valid: this.state.agentDataValid,
                agent_bank_account: this.state.agentBankAccount,
                agent_inquiry_account_response: this.state.agentInquiryAccountResponse,
            }
        }

        await this.promisedSetState({qcProcess: true});
        try {
            await offerGeneralApiService.setToken(this.props.token);
            await offerGeneralApiService.updateOffer(qcData)
                .then(async successData => {
                    Modal.success({
                        title: 'Proses Sukses',
                        content: 'QC berhasil dilakukan',
                    });
                    await this.promisedSetState({qcProcess: false});
                    this.props.onCloseUpdateOwnerIdCardProps("close");
                });
        } catch (e) {
            Modal.error({title: 'Proses Gagal', content: 'Server Menolak Inputan Anda :' + e});
            await this.promisedSetState({qcProcess: false});
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        const listCommissionUsedName = [];
        for (const item of this.state.dataDetailOffer?.detail_commission ?? []) {
            listCommissionUsedName.push(item?.code);
        }

        return (
            <>
                <div style={this.state.fetchingDetailGeneralOffer ? {} : {display: "none"}} className={`spinCenter`}>
                    <Spin size="large"/>
                </div>

                <div style={!this.state.fetchingDetailGeneralOffer ? {} : {display: "none"}}>
                    <Row>
                        <Col sm={24} xl={24}>
                            <Row>
                                <Col xl={12} sm={24} xs={24}>
                                    <div style={{padding: 20}}>
                                        <div className={`mt-5`}>
                                            <i className={`small-text-grey`}>Nama Pemilik:</i><br/>
                                            {this.state.dataDetailOffer?.id_card_owner?.full_name}<br/>
                                        </div>
                                        <div className={`mt-5`}>
                                            <i className={`small-text-grey`}>Nomor KTP Pemilik:</i><br/>
                                            {this.state.dataDetailOffer?.id_card_owner?.id_card_number}<br/>
                                        </div>
                                        <div className={`mt-5`}>
                                            <i className={`small-text-grey`}>Nilai Pendanaan:</i><br/>
                                            {currencyFormat(this.state.dataDetailOffer?.credit?.disbursed_amount)}<br/>
                                        </div>
                                        <div className={`mt-5`}>
                                            <i className={`small-text-grey`}>Tenor:</i><br/>
                                            {this.state.dataDetailOffer?.credit?.tenor}<br/>
                                        </div>
                                        <div className={`mt-5`}>
                                            <i className={`small-text-grey`}>Finco:</i><br/>
                                            {this.state.dataDetailOffer?.credit?.finco_code?.toUpperCase()} - {this.state.dataDetailOffer?.credit?.finco_name?.toUpperCase()}<br/>
                                        </div>
                                        <Divider/>
                                        <Row className={`pt-10`}>
                                            {this.state.dataDetailOffer?.document?.map((item: any, i: number) =>
                                                <Col key={i} span={6} style={{textAlign: "center"}}>
                                                    <span className={`col-grey-small-80`}>{item?.type === "registration" ? "STNK" : item?.type === "ownership" ? "BPKB" : item?.type === "notice" ? "notice" : item?.type}</span><br/>
                                                    <Image style={{height: "50px"}} src={item?.image}/>
                                                </Col>
                                            )}
                                        </Row>
                                    </div>
                                </Col>
                                <Col xl={12} sm={24} xs={24}>
                                    <div style={this.state.ocrResultBpkbNumber ? {padding: 10} : {padding: 10}}>
                                        <Row>
                                            <Col xl={12} sm={24} xs={24} style={{padding: 10}}>
                                                <div>
                                                    <i className={`small-text-grey`}><b className={`required`}>*</b> Nomor BPKB:</i><br/>
                                                    <Input value={this.state.ocrResultBpkbNumber} onChange={event => this.onFieldChange("ocrResultBpkbNumber", event.target.value)} placeholder="Nomor BPKB"/>
                                                </div>
                                                <div className={`mt-5`}>
                                                    <i className={`small-text-grey`}><b className={`required`}>*</b> Nomor Mesin:</i><br/>
                                                    <Input value={this.state.ocrResultEngineNumber} onChange={event => this.onFieldChange("ocrResultEngineNumber", event.target.value)} placeholder="Nomor Mesin"/>
                                                </div>
                                                <div className={`mt-5`}>
                                                    <i className={`small-text-grey`}>Nomor Rangka:</i><br/>
                                                    <Input value={this.state.ecrResultChassisNumber} onChange={event => this.onFieldChange("ecrResultChassisNumber", event.target.value)} placeholder="Nomor Rangka"/>
                                                </div>
                                            </Col>
                                            <Col xl={12} sm={24} xs={24} style={{padding: 10}}>
                                                <div>
                                                    <i className={`small-text-grey`}><b className={`required`}>*</b>Kode Komisi:</i><br/>
                                                    <Search loading={this.state.fetchCommission} placeholder="Kode Komisi" allowClear enterButton="Terapkan" value={this.state.commissionCode} onSearch={this.onSearch} onChange={event => this.onFieldChange("commissionCode", event.target.value)}/>
                                                </div>
                                                <div className={`mt-5`}>
                                                    <i className={`small-text-grey`}><b className={`required`}>*</b> Komisi Finco</i><br/>
                                                    <CurrencyInput className={'ant-input'} disabled={true} value={this.state.fincoCommission} onValueChange={value => this.onFieldChange("fincoCommission", value ? parseFloat(value) : 0)}/>
                                                </div>
                                                <div className={`mt-5`}>
                                                    <i className={`small-text-grey`}>Komisi Agent (Mediator)</i><br/>
                                                    <CurrencyInput className={'ant-input'} disabled={true} value={this.state.agentCommission} onValueChange={value => this.onFieldChange("agentCommission", value ? parseFloat(value) : 0)}/>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Divider/>
                                        <Row>
                                            <Col xl={12} sm={24} xs={24} style={{padding: 5}}>
                                                <b>Rekening Konsumen</b> <CheckCircleTwoTone style={this.state.customerInquiryAccountResponse.beneficiaryAccountName ? {} : {display: "none"}} twoToneColor="#52c41a"/>
                                                <Row className={`pt-5`}>
                                                    <Col xs={24} xl={8} className={`small-text-grey`}>Bank:</Col>
                                                    <Col xs={24} xl={16}>{this.state.customerBankAccount?.bank_short_name?.toUpperCase()}</Col>
                                                </Row>
                                                <Row className={`pt-5`}>
                                                    <Col xs={24} xl={8} className={`small-text-grey`}>Nomor Akun:</Col>
                                                    <Col xs={24} xl={16}>{this.state.customerBankAccount?.account_number?.toUpperCase()}</Col>
                                                </Row>
                                                <Row className={`pt-5`}>
                                                    <Col xs={24} xl={8} className={`small-text-grey`}>Nama Akun:</Col>
                                                    <Col xs={24} xl={16}>{this.state.customerBankAccount?.account_name?.toUpperCase()}</Col>
                                                </Row>
                                                <Button style={this.state.customerDataValid && !this.state.customerInquiryAccountResponse.beneficiaryAccountName ? {marginTop: 10} : {display: "none"}} size={`small`} loading={this.state.fetchValidateBankAccount} type="primary" onClick={() => this.onValidate("customer")}>Validasi Akun</Button>
                                            </Col>
                                            <Col xl={12} sm={24} xs={24} style={{padding: 5}}>
                                                <b>Rekening Agent</b> <CheckCircleTwoTone style={this.state.agentInquiryAccountResponse.beneficiaryAccountName ? {} : {display: "none"}} twoToneColor="#52c41a"/>
                                                <Row className={`pt-5`}>
                                                    <Col xs={24} xl={8} className={`small-text-grey`}>Bank:</Col>
                                                    <Col xs={24} xl={16}>{this.state.agentBankAccount?.bank_short_name?.toUpperCase()}</Col>
                                                </Row>
                                                <Row className={`pt-5`}>
                                                    <Col xs={24} xl={8} className={`small-text-grey`}>Nomor Akun:</Col>
                                                    <Col xs={24} xl={16}>{this.state.agentBankAccount?.account_number?.toUpperCase()}</Col>
                                                </Row>
                                                <Row className={`pt-5`}>
                                                    <Col xs={24} xl={8} className={`small-text-grey`}>Nama Akun:</Col>
                                                    <Col xs={24} xl={16}>{this.state.agentBankAccount?.account_name?.toUpperCase()}</Col>
                                                </Row>
                                                <Button style={this.state.agentDataValid && !this.state.agentInquiryAccountResponse.beneficiaryAccountName ? {marginTop: 10} : {display: "none"}} size={`small`} loading={this.state.fetchValidateBankAccount} type="primary" onClick={() => this.onValidate("agent")}>Validasi Akun</Button>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/*<div style={this.state.ocrResultBpkbNumber ? {display: 'none'} : {textAlign: "center"}}>*/}
                                    {/*    <Spin style={{marginTop: 20}}/><br/><span>Loading OCR Result...</span>*/}
                                    {/*</div>*/}
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={24} xl={24}>
                            <Row>
                                <Col xs={24} xl={12}>
                                </Col>
                                <Col xs={24} xl={12}>
                                    <Divider/>
                                    <div>
                                        Apakah anda yakin untuk merubah status offer <b>{this.state?.dataDetailOffer?.transaction_code}</b> menjadi telah di QC ?
                                    </div>
                                    <Divider/>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={24} xl={24}>
                            <div style={{float: "right", marginTop: 20}}>
                                <Button key="2" disabled={this.state.ocrProcess || this.state.fetchValidateBankAccount} loading={this.state.qcProcess} type="primary" onClick={this.saveBeforeQc}>Save</Button>
                                &nbsp;&nbsp;
                                <Button key="0" disabled={this.state.ocrProcess || this.state.fetchValidateBankAccount} loading={this.state.qcProcess} type="primary" danger={true} onClick={this.finalQc}>Lakukan QC</Button>
                                &nbsp;&nbsp;
                                <Button key="1" type="default" onClick={() => this.props.onCloseUpdateOwnerIdCardProps("close")}>Tutup</Button>
                            </div>
                        </Col>
                    </Row>
                </div>

                <Modal
                    open={this.state.freezeStatusChangeName}
                    closeIcon={true}
                    footer={[
                        <Button key={'okCustomer'} type="primary" onClick={() => {
                            this.setState({freezeStatusChangeName: false});
                        }}>Gunakan data Bank </Button>,
                        <Button key={'closeCustomer'} type="default" onClick={() => {
                            this.setState({freezeStatusChangeName: false});
                            this.props.onCloseUpdateOwnerIdCardProps("close");
                        }}> Batalkan proses QC </Button>
                    ]}
                >
                    <div style={{textAlign: "left", padding: 20}}>
                        Data rekening valid, terdapat perbedaan nama pemilik rekening.<br/><br/>
                        <div dangerouslySetInnerHTML={{__html: this.state.freezeStatusDiffName}}/>
                    </div>
                </Modal>

                <Modal
                    open={this.state.freezeStatusWrongData}
                    closeIcon={true}
                    footer={[
                        <Button key={'closeCustomer'} type="default" onClick={() => {
                            this.setState({freezeStatusWrongData: false});
                            this.props.onCloseUpdateOwnerIdCardProps("close");
                        }}> Close </Button>,
                    ]}
                >
                    <div style={{textAlign: "center", padding: 20}}>
                        Data rekening tidak valid, silakan lakukan update data rekening sebelum melakukan QC.
                        <br/><br/>
                        <code></code><br/>
                        <code style={{fontSize: "85%"}}>{this.state.freezeStatusWrongDataText}</code>
                    </div>
                </Modal>
            </>
        );
    }
}

export default QcLoan;